import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const meridian: Collection = {
  id: 's-and-p-meridian',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Meridian Groen/Blauw',
  subTitle: 'Stijlvol en feestelijk',
  banner: 'meridian/meridian_banner.jpg',
  items: [
    {
      id: 's-and-p-meridian-1',
      collectionImages: [
        {
          image: 'meridian/Meridian_10.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'meridian/Meridian_9.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-meridian-2',
      collectionImages: [
        {
          image: 'meridian/Meridian_2.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'meridian/Meridian_3.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-meridian-3',
      collectionImages: [
        {
          image: 'meridian/Meridian_4.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'meridian/Meridian_12.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        },
        {
          image: 'meridian/Meridian_10.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-meridian-4',
      collectionImages: [
        {
          image: 'meridian/Meridian.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'meridian/Meridian_1.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        }
      ]
    }
  ],
  salesArticleIds: [
    'b53ca083-9b10-4906-9502-933b3c514f38',
    'ad144f18-7fdb-413f-a5a1-c6bf4d5e41e1',
    'bdd44681-61a2-480f-adbc-e512712e183c',
    '5617510b-7af2-449c-be30-4a8998250457',
    'd1365f71-afb1-46db-86ad-02886b4171af',
    'c70dfe6b-0dca-41cc-af0d-9bbbf671cb78',
    '720f1f38-ec34-4933-bd6c-070564e3a39d',
    'e8b8ee2c-a0c5-419c-87a1-5303fedfec11',
    '4bed376b-58d9-4888-800d-2b019d3639a4',
    '7f728517-248d-425b-a508-9831bd6a4979',
    'd910e2fb-2748-4ae2-8d86-cbc23deb1d92',
    '48f312dc-77b9-4586-b29f-c1e254c1bf1a',
    'e52eea84-0de3-430d-a8ee-9febfc099ce6',
    '4684c0b5-4317-45a4-b4c4-98cf7117b5c2',
    'c1f03012-3276-48d2-8d70-c26af0076674',
    'f0e82133-b7fe-42aa-9832-d021b3214667',
    '4be222bc-7d0e-4797-87e3-2229ac3412c7',
    '1d23726d-f29c-409b-a10d-4e35e035e0dd',
    'dad82e4e-3afc-46d1-89fb-f294ea13247a',
    'a9719392-e5d8-4aa0-825a-516b47ceef4b',
    'fe9fc02c-5fb2-4b10-b8b2-3940adb1c8c9',
    '8301bda3-c63d-430e-a2be-034a9cf41ba6',
    '99027ddf-85f8-4b11-92f3-524da0140f03',
    '0d50ad5e-698c-4801-965d-60e0f1701fa0',
    '59c48795-4c12-4f3b-b976-081725440dcb',
    '242e8a2f-a0af-40b6-a447-484c657f8147',
    '6ca22f77-64b6-42d6-9e19-c3208ae47df6',
    '78150f43-bea9-44d6-826f-7bcb3165c5fc',
    '50bf6b51-8bf2-4829-9392-7bb184b9322c',
    '015e8d5a-0fd8-4a38-a689-66ffa8d53357',
    'a146680d-c68a-4f37-8f09-952710f75573',
    'dc8cbd92-d2cd-4186-a9b7-a79e1723c953',
    '1a4bae8b-231c-473f-a1eb-b076ebb64d9d',
    '597596de-88c0-407c-8880-94a6b24dd405',
    '339b4fbc-9f91-45fe-949a-8739343ef70b',
    'e21cc869-2a33-4f15-8d38-7d641b28084a',
    'f134dac9-f8bd-4080-b95e-b3f709e22ab3',
    '5156b84d-f871-4a6d-b87b-38a62ae9fa5f',
    'bb4e4c7b-b255-4ba9-921a-fa8513d59a6e'
  ]
};
